'use client';

import React from 'react';
import PageNotices from '@/components/Notices/PageNotices';
import { Toaster } from '@core/components/ui/sonner';
import { TooltipProvider } from '@core/components/ui/tooltip';
import TranslationsProvider from '@/contexts/translation.provider';

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <TranslationsProvider>
      <PageNotices />
      <TooltipProvider>
        <main id='main-content'>{children}</main>
        <Toaster />
      </TooltipProvider>
    </TranslationsProvider>
  );
}

export default Layout;
